/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionPropertySearchCompletionRequirement } from './EmployeeExecutionPropertySearchCompletionRequirement';
import type { EmployeeExecutionPropertySearchGoal } from './EmployeeExecutionPropertySearchGoal';
/**
 * Property search whose result semantics are explicit.
 */
export type EmployeeExecutionPropertySearchOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionPropertySearchOperation.kind;
    /**
     * Self-contained business search request containing all known criteria.
     */
    query: string;
    /**
     * Business outcome pursued by the search.
     */
    searchGoal: EmployeeExecutionPropertySearchGoal;
    /**
     * Evidence threshold required before the operation is complete.
     */
    completionRequirement: EmployeeExecutionPropertySearchCompletionRequirement;
};
export namespace EmployeeExecutionPropertySearchOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        PROPERTY_SEARCH = 'property-search',
    }
}

